import {CommonReducer, ReducerFromState} from "../../@types/reducers";
import {ExtraMarketData} from "../../@types/response";

export const getExtraMarkets = (state: ReducerFromState<CommonReducer>): ExtraMarketData => state.common.extraMarkets;